// Reset the module-level Legend feed stores on logout / account deletion.
// React Query + localStorage clears don't touch these in-memory observables, so
// on a shared browser an SPA logout (react-router nav, no full reload) would
// otherwise leak the previous user's feed, likes, watch-time, and generated
// activities into the next session. (The 401 path full-reloads, so it's covered
// there already.)
import {
  chapters$,
  feedCurrentIndex$,
  feedHasMore$,
  feedIsLoadingMore$,
  skipChapterIDs$,
} from "./feedState";
import {
  lessonDataCache$,
  generatedActivities$,
  maxPositionReachedMs$,
  completedActivities$,
  wordStatusOverrides$,
} from "./videoState";
import {
  likedChapters$,
  totalElapsedSeconds$,
  dailyElapsedSeconds$,
  dailyElapsedDate$,
} from "./userState";

export function resetFeedState(): void {
  chapters$.set([]);
  feedCurrentIndex$.set(0);
  feedHasMore$.set(true);
  feedIsLoadingMore$.set(false);
  skipChapterIDs$.set([]);

  lessonDataCache$.set({});
  generatedActivities$.set({});
  maxPositionReachedMs$.set({});
  completedActivities$.set({});
  wordStatusOverrides$.set({});

  likedChapters$.set({});
  totalElapsedSeconds$.set(0);
  dailyElapsedSeconds$.set(0);
  dailyElapsedDate$.set("");
}
